import React, {Component} from "react";
import PropTypes from 'prop-types';
import {connect} from "react-redux";
// import Select from 'react-select';
import { withRouter } from 'react-router';

import {REQUEST_TYPE} from "../const/request";
import {createForm, addValue, getDirections} from "../actions";

import LoadingDots from "./ui/LoadingDots";
import {CompanyInfo} from './program/CompanyInfo';

class RequestCreate extends Component {
  modal

  constructor() {
    super();
    this.state = {
        selectedType: REQUEST_TYPE.find(
            (requestType) => requestType.label === "Менторская программа"
        ),
    };
  }

  // componentDidMount() {
  //   this.props.getDirections();
  //   const { location } = this.props;
    
  //   if (location.query.select) {
  //     const selectedTypeFromParams = REQUEST_TYPE.find(requestType => requestType.label === location.query.select.replaceAll('"', ''));
  //     this.onSelect('selectedType', selectedTypeFromParams);
  //   }
  // }

  onSelect = (state, value) => {
    const toSet = {};
    toSet[state] = value ? value : null;
    this.setState(toSet);
  }

  onCreate = () => {
    this.props.createForm(this.state);
  }

  render() {
    const { companies, loaders } = this.props;
    // const {selectedType} = this.state;

    return (
      <LoadingDots show={typeof loaders['companies'] !== 'undefined' || !this.props.modeLoaded}>
        {companies.length > 0 && (
          <div className="text-block">
            <div className="from-group">
              <div className="row">
                <div className="col-sm-4 col-xs-12" style={{marginBottom: '30px'}}>
                  <a
                    href={`${window.location.origin}/regm/files/denial-of-responsibility.docx`}
                    style={{
                      color: '#3377ff',
                      cursor: 'pointer',
                      fontSize: '16px',
                      fontWeight: 'bold'
                    }}
                  >
                    Дисклеймер о разграничении ответственности
                  </a>
                </div>
              </div>
              <div className="row">
                {/* <div className="col-sm-5 col-xs-12">
                  <label>Тип заявки:</label>
                  <Select
                    autosize={false}
                    name="form-field-name"
                    placeholder="Выберите из списка"
                    value={selectedType}
                    style={{borderColor: "#ccc" }} // : "#4eb43e"
                    onChange={value => this.onSelect('selectedType', value)}
                    options={REQUEST_TYPE}
                  />
                </div> */}

                <div className="col-sm-2 col-xs-12">
                  {/* <label>&nbsp;</label> */}
                  <button
                    type="button"
                    className="btn btn-success btn-sm w-btn"
                    onClick={this.onCreate}
                  >
                    Создать заявку
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {companies.length === 0 && (
          <div className='text-block text-block_empty'>
            Не найдено ни одной компании
          </div>
        )}

        <CompanyInfo
          ref={(modal) => this.modal = modal }
          programUid={0}
          onSend={this.onCreateEntity}
        />
      </LoadingDots>
    )
  }
}

RequestCreate.propTypes = {
  companies: PropTypes.array.isRequired,
  loaders: PropTypes.shape({}).isRequired,
  forms: PropTypes.array.isRequired,
  directions: PropTypes.array,
  user: PropTypes.shape({}).isRequired,
};

RequestCreate.defaultProps = {
  directions: []
};

const mapDispatchToProps = {
  createForm,
  addValue,
  getDirections,
};

function mapStateToProps(state) {
  return {
    companies: state.forms.companies,
    loaders: state.forms.loaders,
    forms: state.forms.forms,
    modeLoaded: state.forms.modeLoaded,
    flows: state.forms.flows,
    directions: state.forms.directions,
    user: state.forms.user,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(RequestCreate));
